import { user } from '../auth';

function removeAlternativeModules() {
  const alternativeModules = document.querySelectorAll('.edi-replacement-module');
  alternativeModules.forEach(el => {
    el.remove();
  });
}

function removeTaboolaAds() {
  document.querySelectorAll('.news-sponsored-content').forEach(el => {
    el.remove();
  });
}

function removeAddorAds() {
  document.querySelectorAll('.addor-sponsored-content').forEach(el => {
    el.remove();
  });
}

function removeEdiCreativeModules() {
  document.querySelectorAll('.edi-creativo').forEach(el => {
    el.remove();
  });
}

function displayAlternativeModules() {
  const alternativeModules = document.querySelectorAll('.edi-replacement-module');
  alternativeModules.forEach(el => {
    el.style.display = 'block';
  });
}

export default () => {
  // Sólo se elimina para los no-socios ya que estos van a ver el modulo no alternativo
  if (!user.isPartner) {
    removeAlternativeModules();
    return;
  }

  displayAlternativeModules();
  removeEdiCreativeModules();
  removeTaboolaAds();
  removeAddorAds();
}
